export const styles = {
  page: {
    minHeight: "100vh",
    background: "#f0ede8",
    fontFamily: "'Georgia', 'Times New Roman', serif",
    padding: "2rem 1rem",
  },
  card: {
    maxWidth: 900,
    margin: "0 auto",
    background: "#fff",
    border: "2px solid #1a1a1a",
    boxShadow: "6px 6px 0px #1a1a1a",
  },
  header: {
    borderBottom: "3px double #1a1a1a",
    padding: "2rem 2.5rem 1.5rem",
    textAlign: "center",
  },
  title: {
    fontSize: "1.35rem",
    fontWeight: 700,
    letterSpacing: "0.18em",
    textTransform: "uppercase",
    textDecoration: "underline",
    marginBottom: 0,
    color: "#1a1a1a",
  },
  section: { padding: "1.5rem 0.5rem" },
  sectionBorder: {
    // borderTop: "1px solid #ccc",
    padding: "1.5rem 0.5rem",
  },
  fieldGrid: {
    // display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "0.75rem 1.2rem",
  },
  fieldRow: {
    display: "flex",
    alignItems: "baseline",
    gap: "0.5rem",
    marginBottom: "0.6rem",
  },
  label: {
    fontSize: "0.82rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
    color: "#1a1a1a",
    minWidth: 140,
  },
  input: {
    flex: 1,
    border: "none",
    borderBottom: "1px solid #666",
    outline: "none",
    fontSize: "0.85rem",
    background: "transparent",
    padding: "2px 4px",
    color: "#1a1a1a",
  },
  sectionLabel: {
    fontSize: "0.83rem",
    fontWeight: 700,
    textTransform: "capitalize" as const,
    // letterSpacing: "0.05em",
    // textTransform: "uppercase" as const,
    color: "#1a1a1a",
    marginBottom: "0.25rem",
  },
  note: {
    fontSize: "0.83rem",
    color: "#444",
    // fontStyle: "italic",
    marginBottom: "1rem",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse" as const,
    fontSize: "0.78rem",
  },
  th: {
    border: "1px solid #999",
    padding: "6px 8px",
    textAlign: "center" as const,
    background: "#f5f3ef",
    fontWeight: 600,
    fontSize: "0.72rem",
  },
  thLeft: {
    border: "1px solid #999",
    padding: "6px 8px",
    textAlign: "left" as const,
    background: "#f5f3ef",
    fontWeight: 700,
    fontSize: "0.72rem",
    letterSpacing: "0.04em",
  },
  td: {
    border: "1px solid #999",
    padding: "8px",
    textAlign: "center" as const,
    verticalAlign: "middle" as const,
  },
  tdLeft: {
    border: "1px solid #999",
    padding: "12px 8px",
    textAlign: "left" as const,
    verticalAlign: "top" as const,
    minWidth: "160px",
    maxWidth: 220,
    fontSize: "0.8rem",
    lineHeight: 1.4,
  },

  radioCustom: (checked: boolean) => ({
    width: 16,
    height: 16,
    border: `2px solid ${checked ? "#1a1a1a" : "#888"}`,
    borderRadius: 2,
    background: checked ? "#1a1a1a" : "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
  }),
  checkmark: { color: "#fff", fontSize: 10, fontWeight: 700, lineHeight: 1 },
  attendanceGrid: {
    display: "flex" as const,
    // gap: "0.5rem",
    gap: "0",
    flexWrap: "wrap" as const,
    margin: "0.75rem 0",
  },

  attendanceBtn: (selected: boolean) => ({
    padding: "6px 18px",
    border: "1px solid #1a1a1a",
    background: "#fff",
    color: "#333",
    fontSize: "0.85rem",
    cursor: "pointer",
    fontFamily: "inherit",
    fontWeight: 400,
    transition: "all 0.15s",
    // border: `1px solid ${selected ? "#1a1a1a" : "#999"}`,
    // background: selected ? "#1a1a1a" : "#fff",
    // color: selected ? "#fff" : "#333",
    // fontWeight: selected ? 600 : 400,
  }),

  outcomeCard: (selected: boolean) => ({
    // border: `2px solid ${selected ? "#1a1a1a" : "#ccc"}`,
    background: selected ? "#f5f3ef" : "#fff",
    padding: "1rem 1.25rem",
    marginBottom: "0.75rem",
    cursor: "pointer",
    transition: "all 0.15s",
  }),
  outcomeHeader: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    marginBottom: "0.5rem",
  },

  submitBtn: {
    display: "block",
    margin: "0 auto",
    padding: "10px 48px",
    background: "#1a1a1a",
    color: "#fff",
    border: "none",
    fontSize: "0.85rem",
    letterSpacing: "0.1em",
    fontFamily: "inherit",
    fontWeight: 600,
    cursor: "pointer",
    textTransform: "uppercase",
  },
};
